module.exports = __webpack_public_path__ + "img/bg3.91e850c0.png";